import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { Icon } from '@iconify/react';
import {
  FaWeight, // Aids Weight Management
  FaSmile, // No Aftertaste
  FaHandHoldingMedical, // Diabetic Friendly
  FaRegCircle, // Zero Calories
  FaChartLine, // No Insulin Spike
  FaCube, // No Artificial Ingredients
  FaBrain,
  FaBookOpen,
  FaShieldAlt,
  FaBolt,
} from 'react-icons/fa';

const features = [
  { icon: <FaWeight size={34} />, text: 'Supports Muscle Growth' },
  { icon: <FaSmile size={34} />, text: 'Smooth Taste & Easy to Digest' },
  {
    icon: <FaHandHoldingMedical size={34} />,
    text: 'Boosts Recovery & Performance',
  },
  { icon: <FaRegCircle size={34} />, text: 'Low Calories, High Protein' },
  { icon: <FaChartLine size={34} />, text: 'Helps Maintain Energy Levels' },
  { icon: <FaCube size={34} />, text: 'No Artificial Additives' },
];
const reviewsData = [
  {
    id: 1,
    name: 'Riddhi',
    verified: true,
    rating: 5,
    comment:
      'I first saw the product on Instagram and bought it impulsively, zero regrets. After my first cup, I was a bit overwhelmed by the emotions...',
    timeAgo: '1 year ago',
    images: ['/images/review1-1.jpg', '/images/review1-2.jpg'],
  },
  {
    id: 2,
    name: 'Ishaan Shirsat',
    verified: true,
    rating: 5,
    comment: 'This product changed my mornings completely. Highly recommend!',
    timeAgo: '6 months ago',
    images: [],
  },
];

const Productdetails = () => {

  const [selectedPack, setSelectedPack] = useState('sachet');
  const [selectedFlavour, setSelectedFlavour] = useState('');
  const [isExpanded, setIsExpanded] = useState('');
  const [activeIndex, setActiveIndex] = useState(null);
   const totalStars = 5;
  const [showForm, setShowForm] = useState(false);
  const [reviews, setReviews] = useState(reviewsData);
  const [expanded, setExpanded] = useState(null);
  const [reviewText, setReviewText] = useState('');
  const [rating, setRating] = useState(0);
  const [selectedTag, setSelectedTag] = useState(null);
  const [activeSection, setActiveSection] = useState(null);
      const [openIndex, setOpenIndex] = useState(null);
        const [showFaqs, setShowFaqs] = useState(false);
      
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  
  const filteredReviews = selectedTag
    ? reviews.filter((r) => r.tags.includes(selectedTag))
    : reviews;

  const handleSubmitReview = () => {
    if (!reviewText || rating === 0) return;

    const newReview = {
      id: Date.now(),
      name: 'You',
      verified: false,
      rating,
      comment: reviewText,
      timeAgo: 'Just now',
      images: [],
    };

    setReviews([newReview, ...reviews]);
    setReviewText('');
    setRating(0);
    setShowForm(false);
  };

      const ingredients = [
    {
      name: 'Fermented Yeast Protein',
      description: 'Clean protein support for everyday nutrition',
      img: '/assets/images/collagen_ace.webp',
    },
    {
      name: 'Digestive Enzymes (Papain)',
      description: 'Help support comfortable protein breakdown',
      img: '/assets/images/Digestive_Enzymes.webp',
    },
    {
      name: 'Coffee Powder',
      description: 'Natural coffee flavour with a smooth, balanced taste',
      img: '/assets/images/Coffee_Powder.webp',
    },
    {
      name: 'Monk Fruit Concentrate',
      description: 'Adds sweetness without added sugar',
      img: '/assets/images/Monk_Fruit_Concentrate.webp',
    },

    {
      name: 'Inactive Dried Yeast (Saccharomyces cerevisiae)',
      description: 'Naturally rich source of yeast nutrients',
      img: '/assets/images/Inactive_Dried_Yeast.webp',
    },
  ];

  const flavours = [
    {
      id: 1,
      name: 'Cafe Mocha ',
      img: '/assets/images/Yeast_Protein.png',
      popular: true,
    },
    {
      id: 2,
      name: 'Double Chocolate',
      img: 'assets/images/Yeast_protein1.jpg',
      popular: false,
    },
  ];
  const certifications = [
  { img: '/assets/images/fda.png', alt: 'FDA' },
  { img: '/assets/images/Haccp.webp', alt: 'HACCP' },
  { img: '/assets/images/gmp_converted.webp', alt: 'GMP' },
  { img: '/assets/images/iso_converted.webp', alt: 'ISO' },
  { img: '/assets/images/fssai.jpg', alt: 'FSSAI' },
  { img: '/assets/images/non-gmo.jpg', alt: 'Non GMO' },
];
 const faqs = [
  {
    question: 'What exactly is fermented yeast protein?',
    answer:
      'Fermented yeast protein is made from food-grade yeast that is grown, purified, and converted into a high-quality protein powder. It delivers complete protein — without dairy — and is designed to feel lighter than typical protein powders.',
  },
  {
    question: 'Is it safe to consume every day?',
    answer:
      'Yes — when taken as directed. Yeast has been used in foods for decades, and the protein is carefully filtered before it reaches your scoop. If you have a specific yeast allergy or medical condition, check with your doctor first.',
  },
  {
    question: 'How is it different from whey protein?',
    answer:
      'Whey is dairy-based. Fermented yeast protein is dairy-free and lactose-free, which many people find easier on digestion. Both can support protein needs — yeast protein simply gives you a lighter, cleaner alternative.',
  },
  {
    question: 'Will it cause gas, heaviness, or bloating?',
    answer:
      'Most people choose fermented yeast protein because it feels lighter. Fermentation and added digestive support are designed to make it easier to tolerate. If you’re sensitive, start with half a scoop.',
  },
  {
    question: 'Is it the same as plant protein?',
    answer:
      'No — it isn’t pea or soy protein. It’s made from fermented yeast and offers a complete amino acid profile without needing blends. Many people prefer it over plant proteins for its lighter texture.',
  },
  {
    question: 'How much protein do I get per scoop?',
    answer:
      'Each serving provides 23g protein plus 5.09g BCAAs per scoop — ideal for post-workout, busy mornings, or filling daily nutrition gaps.',
  },
  {
    question: 'Is it suitable for vegans and vegetarians?',
    answer:
      'Yes — it’s vegetarian and dairy-free. If you strictly follow a vegan lifestyle, the product fits most preferences, but always review the label to be sure.',
  },
  {
    question: 'Does it contain sugar?',
    answer:
      'No added sugar. It’s sweetened with monk fruit and zero-calorie sweeteners for taste without extra calories.',
  },
  {
    question: 'Can I take it if I don’t go to the gym?',
    answer:
      'Absolutely. Protein supports daily energy, muscle maintenance, recovery from routine activity, and balanced nutrition — not just workouts.',
  },
  {
    question: 'When should I take it?',
    answer:
      'Anytime that fits your routine — after workouts, in breakfast smoothies, between meals, or as an evening recovery drink. Consistency matters more than timing.',
  },
  {
    question: 'How do I mix it?',
    answer:
      'Mix with cold water, milk or plant milk, or add to smoothies, oats, or recipes. Shake or blend until smooth. Avoid very hot liquids.',
  },
  {
    question: 'Can teenagers or elderly people use it?',
    answer:
      'It may be used as part of a normal diet. Teenagers should check with a parent or doctor if using regularly. Elderly individuals, especially those on medication, should consult a doctor first. It is not a meal replacement.',
  },
  {
    question: 'Can pregnant or breastfeeding women use it?',
    answer:
      'Please consult your doctor first. We don’t recommend starting any new supplement during pregnancy or breastfeeding without medical approval.',
  },
  {
    question: 'Will it help me lose weight?',
    answer:
      'Protein can help control cravings and support metabolism, but it is not a fat-loss product. Healthy eating and regular activity matter most.',
  },
  {
    question: 'Does it contain allergens?',
    answer:
      'It is dairy-free, lactose-free, and soy-free. However, it may be processed in a facility that handles other ingredients — always check the label if you have severe allergies.',
  },
];

const productData = {
  'Product Name': 'Fermented Yeast Protein',
  Ingredient:
    'Fermented Yeast Protein, Coffee Powder/ Cocoa Powder, Monk Fruit Juice Concentrate, Stabilizer (INS 415), Anticaking Agent (INS 551), Digestive Enzymes (Papain), Nature Identical Flavouring Substances – Café Mocha Flavour/Double Chocolate, Inactive Dried Yeast (Saccharomyces cerevisiae).',
  MRP: '2999 (incl. of all taxes)',
  Barcode: '743966049194',
  // Dimensions: '11 x 9 x 9 cm',
  Weight: '1 kg',
  'Shelf Life': '18 months',
  'Country Of Origin': 'India',
  'Marketer Details With FSSAI Logo & License No.':
    'Ward No. 11, Behind BR 45 Restaurant, Kachahari Road, Bhabua (Kaimur),Bihar – 821101 FSSAI Lic. No:10425999000324',
  'Manufacturer Details With FSSAI Logo & License No.':
    'Plot No. D-173, Gf At Phase 8B Indl Focal Point,Mohali, Punjab – 160055 FSSAI Lic. No.:12122999000378',
};
const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

      const [activeFaqIndex, setActiveFaqIndex] = useState(null);
      const toggleSection = (index) => {
        // If the same section is open, close it
        if (activeSection === index) {
          setActiveSection(null);
          setOpenIndex(null); // also close FAQ items
        } else {
          setActiveSection(index);
          setOpenIndex(null); // reset FAQ openIndex
        }
      };

  return (
    <>
      <Navbar />

      {/* <!-- Product Left Sidebar Start --> */}
      <section className="product-section">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12  wow fadeInUp">
              <div className="row g-4">
                <div className="col-xl-6 wow fadeInUp">
                  <div className="product-left-box">
                    <div className="row g-sm-4 g-2">
                      <div className="col-12">
                        <div className="product-main no-arrow">
                          <div>
                            <div className="slider-image">
                              <img
                                src="/assets/images/Yeast_Protein.png"
                                id="img-1"
                                data-zoom-image="/assets/images/Yeast_Protein.png"
                                className="img-fluid image_zoom_cls-0 blur-up lazyload"
                                alt="img"
                                style={{ width: '80%' }}
                              />
                            </div>
                          </div>

                          <div>
                            <div className="slider-image">
                              <img
                                src="/assets/images/Yeast_Protein.png"
                                data-zoom-image="/assets/images/Yeast_Protein1.png"
                                className="
                                                        img-fluid image_zoom_cls-2 blur-up lazyload"
                                alt="img"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 wow fadeInUp">
                  <div className="right-box-contain">
                    <h6 className="offer-top">30% Off</h6>
                    <h2
                      className="name"
                      style={{ fontSize: '20px' }}
                    >
                      Fermented Yeast Protein 1kg Pouch - Evercore Fermented Yeast Protein | 23g
                      Complete Protein | Peak Absorption | Gut-Friendly
                    </h2>
                    <div className="price-rating">
                      <h3 className="theme-color price">
                        ₹2299<del className="text-content">₹2999</del>{' '}
                        <span className="offer theme-color">(8% off)</span>
                        <p className="text-content">23g protein per scoop (33g scoop size).</p>
                      </h3>
                      <div className="product-rating custom-rate">
                        <ul className="rating">
                          <li>
                            <i
                              data-feather="star"
                              className="fill"
                            ></i>
                          </li>
                          <li>
                            <i
                              data-feather="star"
                              className="fill"
                            ></i>
                          </li>
                          <li>
                            <i
                              data-feather="star"
                              className="fill"
                            ></i>
                          </li>
                          <li>
                            <i
                              data-feather="star"
                              className="fill"
                            ></i>
                          </li>
                          <li>
                            <i data-feather="star"></i>
                          </li>
                        </ul>
                        <span className="review">23 Customer Review</span>
                      </div>
                    </div>

                    <div className="mt-4">
                      <svg
                        width="100%"
                        height="70"
                        viewBox="0 0 900 70"
                        preserveAspectRatio="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {/* Background */}
                        <rect
                          x="0"
                          y="0"
                          width="900"
                          height="70"
                          fill="#FFD35A"
                        />

                        {/* Left Zig-Zag */}
                        <polygon
                          fill="#fff"
                          points="
        0,0 15,7 0,14 15,21 0,28
        15,35 0,42 15,49 0,56 15,63 0,70
      "
                        />

                        {/* Right Zig-Zag */}
                        <polygon
                          fill="#fff"
                          points="
        900,0 885,7 900,14 885,21 900,28
        885,35 900,42 885,49 900,56 885,63 900,70
      "
                        />

                        {/* Lightning Icon */}
                        <text
                          x="40"
                          y="35"
                          fontSize="28"
                          fontWeight="700"
                          fill="#2a2a2a"
                          dominantBaseline="middle"
                          textAnchor="middle"
                        >
                          ⚡
                        </text>

                        {/* Main Text */}
                        <text
                          x="80"
                          y="25"
                          fontSize="16"
                          fontWeight="700"
                          fill="#2a2a2a"
                          fontFamily="Arial, sans-serif"
                        >
                          Use code: NEWYEAR25
                        </text>

                        {/* Sub Text */}
                        <text
                          x="80"
                          y="45"
                          fontSize="14"
                          fill="#2a2a2a"
                          fontFamily="Arial, sans-serif"
                        >
                          Get Flat 15% Off on all orders
                        </text>
                      </svg>
                    </div>

                    <div className="product-package">
                      <div className="product-title">
                        <h4>Pack:</h4>
                      </div>

                      <ul className="rectangle select-package">
                        <li className="form-check">
                          <input
                            className="form-check-input"
                            checked={selectedPack === 'sachet'}
                            type="radio"
                            name="pack"
                            id="sachet"
                            onChange={() => setSelectedPack('sachet')}
                          />
                          <label
                            className={`form-check-label ${
                              selectedPack === 'sachet' ? 'active' : ''
                            }`}
                            htmlFor="sachet"
                          >
                            <span>Sachet</span>
                          </label>
                        </li>

                        <li className="form-check">
                          <input
                            className="form-check-input"
                            checked={selectedPack === 'box'}
                            type="radio"
                            name="pack"
                            id="box"
                            onChange={() => setSelectedPack('box')}
                          />
                          <label
                            className={`form-check-label ${selectedPack === 'box' ? 'active' : ''}`}
                            htmlFor="box"
                          >
                            <span>Box</span>
                          </label>
                        </li>
                      </ul>
                    </div>

                    {/* 👉 Conditional Rendering */}
                    {selectedPack === 'sachet' && (
                      <div className="pack-details">
                        <h5>Sachet Details</h5>
                        <p>23 gram Per Sachet </p>
                      </div>
                    )}

                    {selectedPack === 'box' && (
                      <div className="pack-details">
                        <h5>Box Details</h5>
                        <p>1kg Pouch</p>
                      </div>
                    )}

                    <section>
                      <h3 className="label">Flavours:</h3>
                      <div className="flavour-grid">
                        {flavours.map((f) => (
                          <div
                            key={f.id}
                            className={`flavour-card ${selectedFlavour === f.name ? 'active-flavour' : ''}`}
                            onClick={() => setSelectedFlavour(f.name)}
                          >
                            {f.popular && <span className="popular-badge">Most popular</span>}
                            <div className="img-wrapper">
                              <img
                                src={f.img}
                                alt={f.name}
                              />
                            </div>
                            <p className="flavour-text">{f.name}</p>
                          </div>
                        ))}
                      </div>
                    </section>
                    <div className="bundle-container">
                      <div className="bundle-header">
                        <h1>Focus & Calm Bundle</h1>
                        <p>Get an Extra 5% Off</p>
                      </div>

                      <div className="products">
                        <div className="product-card">
                          <img
                            src="assets/images/Yeast_Protein.png"
                            alt="Lion's Mane Shroom Coffee"
                          />
                          <h3>Cafe Mocha</h3>
                          <p className="price">
                            <span className="old-price">₹2999</span> ₹ 2299
                          </p>
                        </div>

                        <div className="product-card">
                          <img
                            src="assets/images/Yeast_protein1.jpg"
                            alt="Outshine Omega 3"
                          />
                          <h3>Double Chocolate</h3>
                          <p className="price">
                            <span className="old-price">₹2899</span> ₹ 2499
                          </p>
                        </div>
                      </div>

                      <div className="bundle-footer">
                        <div className="total">
                          Total:
                          <span className="old-price"> ₹ 5898</span>
                          <span className="final-price"> ₹ 4798</span>
                          <span className="save">SAVE ₹ 89</span>
                        </div>
                        <button className="add-cart">ADD SELECTED TO CART</button>
                      </div>

                      <div className="buy-box">
                        <a href="/Wishlist">
                          <i
                            data-feather="heart"
                            style={{ color: '#000' }}
                          ></i>
                          <span>Add To Wishlist</span>
                        </a>
                      </div>
                    </div>

                    <div className="features-container">
                      <div className="features-grid">
                        {features.map((f, i) => (
                          <div
                            className="feature-item"
                            key={i}
                          >
                            <div className="icon">{f.icon}</div>
                            <p>{f.text}</p>
                          </div>
                        ))}
                      </div>

                      <p className="description">
                        {isExpanded
                          ? `Built for those who want protein without the bloating, heaviness or dairy, Evercore Fermented Yeast Protein offers clean, complete nutrition with a smooth, dessert-style taste. 

      Fermented yeast delivers a high-quality protein source that’s naturally gut-friendly, while digestive enzymes support easier breakdown and absorption. With 23g protein per scoop, it helps fuel recovery, muscle maintenance, metabolism and daily strength — without compromising on comfort. Available in rich Double Chocolate and Café Mocha flavors, it’s the kind of protein you’ll actually enjoy staying consistent with.`
                          : `Built for those who want protein without the bloating, heaviness or dairy, Evercore Fermented Yeast Protein offers clean, complete nutrition with a smooth, dessert-style taste. `}

                        <span
                          className="read-more"
                          onClick={() => setIsExpanded(!isExpanded)}
                        >
                          {isExpanded ? ' Read less' : ' Read more'}
                        </span>
                      </p>

                      <div className="logo-row">
                        <img
                          src="/assets/images/Frame_1.svg"
                          alt="certification"
                          className="cert-logo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Product Left Sidebar End --> */}

      <section className="use-section">
        <div className="container">
          <h2 className="use-heading">Five Ways to Use It</h2>

          <div className="use-grid">
            <div className="use-card">
              <i className="fa-solid fa-dumbbell use-icon"></i>
              <h3>Post-Workout (1-2 scoops)</h3>
              <p>
                Mix immediately after training for rapid amino acid delivery, muscle support, and
                faster recovery.
              </p>
            </div>

            <div className="use-card">
              <i className="fa-solid fa-mug-hot use-icon"></i>
              <h3>Breakfast Protein Boost</h3>
              <p>
                Add to oats, coffee, or smoothies for a filling, clean-tasting morning protein
                source.
              </p>
            </div>

            <div className="use-card">
              <i className="fa-solid fa-cookie-bite use-icon"></i>
              <h3>Between-Meals Snack</h3>
              <p>
                Have 1 scoop with almond milk or water to prevent hunger and support muscle
                maintenance.
              </p>
            </div>

            <div className="use-card">
              <i className="fa-solid fa-moon use-icon"></i>
              <h3>Pre-Bed Recovery</h3>
              <p>Take before sleep for slow amino acid release and overnight recovery support.</p>
            </div>

            <div className="use-card">
              <i className="fa-solid fa-blender use-icon"></i>
              <h3>High-Protein Recipes</h3>
              <p>
                Blend into pancakes, brownies, smoothies & more for delicious high-protein meals.
              </p>
            </div>
          </div>
        </div>
      </section>

        <section className="yp-protein-section">
        <div className="yp-protein-container">
          {/* Image Space */}
          <div className="yp-protein-image">
            <img
              src="/assets/images/Yeast_Protein.png"
              alt="Fermented Yeast Protein"
            />
          </div>

          {/* Content */}
          <div className="yp-protein-content">
            <h2 className="yp-protein-headline">Clean Protein. No Bloat. Real Results.</h2>

            <div className="yp-benefits-grid">
              <div className="yp-benefit-item">
                <strong>23g Protein + 5.09g BCAAs</strong>
                <p>Supports strength, recovery and performance.</p>
              </div>

              <div className="yp-benefit-item">
                <strong>Dairy-Free. Lactose-Free.</strong>
                <p>A clean alternative to whey.</p>
              </div>

              <div className="yp-benefit-item">
                <strong>With Digestive Enzymes (Papain)</strong>
                <p>Helps support easier tolerance and breakdown.</p>
              </div>

              <div className="yp-benefit-item">
                <strong>No Added Sugar</strong>
                <p>Contains monk fruit + zero-calorie sweeteners.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="after-core-image">
        <div className="container">
          <div className="image-wrapper">
            <img
              src="/assets/images/comaprison-banner1.webp"
              alt="Core Visual"
              loading="lazy"
            />
          </div>
        </div>
      </section>

        <section className="core-with">
        <div className="container">
          <h2 className="title">The Core Within</h2>
          <div className="ingredient-grid">
            {ingredients.map((item, index) => (
              <div
                key={index}
                className="ingredient-card"
              >
                <div className="image-wrapper">
                  <img
                    src={item.img}
                    alt={item.name}
                  />
                </div>
                <div className="content">
                  <h4 className="name">
                    {item.name} <br />
                    <span className="sub">{item.subtext}</span>
                  </h4>
                  <p className="desc">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

        <section className="flavours-new">
        <div className="container">
          <h2 className="flavours-main-title">
            <span>delicious flavours</span>, one goal
          </h2>

          <div className="flavours-center">
            {/* Card 1 */}
            <div className="flavour-card-lg active">
              <img
                src="/assets/images/Yeast_Protein.png"
                alt="Café Mocha"
              />
              <p>Café Mocha </p>
            </div>

            {/* Card 2 */}
            <div className="flavour-card-lg">
              <img
                src="/assets/images/Yeast_protein1.jpg"
                alt="Double Chocolate"
              />
              <p>Double Chocolate </p>
            </div>
          </div>
        </div>
      </section>

        <section className="collapsible-section">
        <div className="container">
          {/* Nutritional Information */}
          <div className={`accordion-item ${activeIndex === 0 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => toggleAccordion(0)}
            >
              <span>Nutritional information</span>
              <span className="icon">{activeIndex === 0 ? '−' : '+'}</span>
            </button>

            <div className="accordion-content">
              <div className="container-fluid">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-10 col-lg-8">
                    <img
                      src="/assets/images/nutritional-information.webp"
                      alt="Nutritional Information"
                      className="img-fluid rounded"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`accordion-item ${activeIndex === 1 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => toggleAccordion(1)}
            >
              <span>Ingredients</span>
              <span className="icon">{activeIndex === 1 ? '−' : '+'}</span>
            </button>

            <div className="accordion-content">
              <div className="ingredients-content">
                <p>
                  Fermented Yeast Protein, Coffee Powder/ Cocoa Powder, Monk Fruit Juice
                  Concentrate, Stabilizer (INS 415), Sweetener (INS 955 & 950), Anticaking Agent
                  (INS 551), Digestive Enzymes (Papain), Nature Identical Flavouring Substances –
                  Café Mocha Flavour. Inactive Dried Yeast (Saccharomyces cerevisiae).
                </p>
              </div>
            </div>
          </div>

          <div className={`accordion-item ${activeIndex === 2 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => toggleAccordion(2)}
            >
              <span> Why choose Evercore Fermented Yeast Protein? </span>
              <span className="icon">{activeIndex === 2 ? '−' : '+'}</span>
            </button>

            <div className="accordion-content">
              <div className="ingredients-content">
                <p>
                  Our fermented yeast protein is designed for people who want clean daily protein —
                  without the digestive heaviness many feel with whey. Each scoop delivers 23g of
                  light, easy-mixing protein along with 5.09g of naturally occurring BCAAs to
                  support strength, recovery and everyday nutrition. Because it’s dairy-free and
                  lactose-free, it fits seamlessly into modern wellness lifestyles and is gentle on
                  most stomachs. Fermentation and added digestive enzymes work together to help
                  support better tolerance — so you can stay consistent without the bloat or
                  discomfort. Sweetened with monk fruit and zero-calorie sweeteners, it keeps sugar
                  out while still tasting smooth and balanced. It’s simple, science-led protein you
                  can use every day — whether you’re training, staying active, or just taking better
                  care of yourself. From workout to glow-up, it fits right in.
                </p>
              </div>
            </div>
          </div>

          <div className={`accordion-item ${activeIndex === 3 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => toggleAccordion(3)}
            >
              <span>When to use Evercore Fermented Yeast Protein</span>
              <span className="icon">{activeIndex === 3 ? '−' : '+'}</span>
            </button>

            <div className="accordion-content">
              <div className="ingredients-content">
                <p>
                  Use it whenever your day needs clean protein — after workouts, in smoothies, busy
                  mornings, or to fill gaps between meals. Each scoop gives 23g protein with 5.09g
                  BCAAs, without the heaviness of whey. Because it’s fermented and dairy-free, it’s
                  designed to be easier on the stomach and simple to stay consistent with — mix,
                  sip, and fuel your routine.
                </p>
              </div>
            </div>
          </div>

          <div className={`accordion-item ${activeIndex === 4 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => toggleAccordion(4)}
            >
              <span>Myths About Fermented Yeast Protein</span>
              <span className="icon">{activeIndex === 4 ? '−' : '+'}</span>
            </button>

            <div className="accordion-content">
              <div className="ingredients-content">
                <div className="card-content">
                  <p style={{ textAlign: 'center', fontSize: '14px' }}>
                    <strong>“It’s just hype.”</strong>
                  </p>
                  <p style={{ textAlign: 'justify' }}>
                    {' '}
                    Fact: It’s a complete, high-quality protein made from food-grade yeast, with
                    strong amino acid quality.
                  </p>
                </div>
                <div className="card-content">
                  <p style={{ textAlign: 'center', fontSize: '14px' }}>
                    <strong>“Whey is always better.”</strong>
                  </p>
                  <p style={{ textAlign: 'justify' }}>
                    {' '}
                    Fact: Whey works for some; yeast protein is a lighter, dairy-free option for
                    people who want less heaviness and discomfort.
                  </p>
                </div>
                <div className="card-content">
                  <p style={{ textAlign: 'center', fontSize: '14px' }}>
                    <strong>“It’s bad for the gut.”</strong>
                  </p>
                  <p style={{ textAlign: 'justify' }}>
                    {' '}
                    Fact: Fermentation can support better digestibility, which is why many people
                    find it easier on the stomach than regular whey.
                  </p>
                </div>
                <div className="card-content">
                  <p style={{ textAlign: 'center', fontSize: '14px' }}>
                    {' '}
                    <strong>It’s only for vegans.”</strong>
                  </p>
                  <p style={{ textAlign: 'center' }}>
                    Fact: It suits vegans, vegetarians and anyone who just wants cleaner, gentler
                    daily protein.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     <section className="evercore-standard">
        <div className="container-fluid-lg">
          <div className="standard-container">
            <span className="standard-eyebrow">THE EVERCORE STANDARD</span>
            <h2>Our Commitment to Quality & Purity</h2>

            <div className="standard-items">
              <div className="standard-item">
                <Icon icon="mdi:leaf" />
                <span>Monk Fruit Sweetened</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:flask-outline" />
                <span>Science-Led Formulation</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:stomach" />
                <span>Easy on Digestion</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:earth" />
                <span>Globally Sourced Ingredients</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:water-off" />
                <span>Preservative Free</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:run" />
                <span>Lifestyle Friendly</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="certification-section">
        <div className="container-fluid-lg">
          <div className="title mb-4">
            <h2>Certifications</h2>
            <span className="title-leaf">
              <svg className="icon-width">
                <use href="../assets/svg/leaf.svg#leaf"></use>
              </svg>
            </span>
          </div>

          <div className="new-slider-wrapper">
            <div className="new-slider-slider">
              {[...certifications, ...certifications].map((item, index) => (
                <div className="cert-item" key={index}>
                  <a href="/Shop" className="cert-card">
                    <img src={item.img} alt={item.alt} />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div
        className="reviews-container"
        style={{ marginTop: '60px' }}
      >
        <div className="reviews-header">
          <h2>Reviews</h2>
          <button
            className="write-review-btn"
            onClick={() => setShowForm(true)}
          >
            Write a Review
          </button>
        </div>

        {/* Existing review mapping logic */}
        {reviews.map((review) => (
          <div
            key={review.id}
            className="review-card"
          >
            <div className="stars">
              {Array.from({ length: totalStars }).map((_, i) => (
                <span
                  key={i}
                  style={{ color: '#FFD700' }}
                >
                  {i < review.rating ? '★' : '☆'}
                </span>
              ))}
            </div>
            <p className="comment">
              {expanded === review.id ? review.comment : `${review.comment.slice(0, 120)}...`}
              {review.comment.length > 120 && (
                <button
                  style={{ border: 'none' }}
                  onClick={() => setExpanded(expanded === review.id ? null : review.id)}
                >
                  {expanded === review.id ? ' Show less' : ' Show more'}
                </button>
              )}
            </p>
            <p className="time">{review.timeAgo}</p>
          </div>
        ))}
      </div>

      {/* --- THE MODAL (FIXED) --- */}
      {showForm && (
        <div className="popup-modal">
          <h3>Write a Review</h3>

          <textarea
            placeholder="How was your experience with Evercore Collagen?"
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
          />

          <div className="rating-input">
            <p>Your Rating:</p>
            {Array.from({ length: 5 }).map((_, i) => (
              <span
                key={i}
                onClick={() => setRating(i + 1)}
              >
                {i < rating ? '★' : '☆'}
              </span>
            ))}
          </div>

          <div className="modal-actions">
            <button
              className="cancel"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
            <button
              className="submit"
              onClick={handleSubmitReview}
            >
              Submit Review
            </button>
          </div>
        </div>
      )}

      {/* collable section */}
      <section className="collapsible-section">
        {/* ================= Lab Reports ================= */}
        <div className="container">
          <div className={`accordion-item ${activeSection === 0 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => toggleSection(0)}
            >
              <span>Lab Reports</span>
              <span className="icon">{activeSection === 0 ? '−' : '+'}</span>
            </button>
            <div className="accordion-content">
              <p>Lab reports content goes here.</p>
            </div>
          </div>
        </div>

        {/* ================= Know More ================= */}
        <div className="container">
          <div className={`accordion-item ${activeSection === 1 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => toggleSection(1)}
            >
              <span>Know More</span>
              <span className="icon">{activeSection === 1 ? '−' : '+'}</span>
            </button>

            <div className="accordion-content">
              <p>Content here....</p>
            </div>
          </div>
        </div>

        {/* ================= FAQs ================= */}
        <div className="container">
          {/* Parent Accordion */}
          <div className={`accordion-item ${activeSection === 2 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => {
                setActiveSection(activeSection === 2 ? null : 2);
                setActiveFaqIndex(null);
                setShowFaqs(false);
              }}
            >
              <span>FAQs</span>
              <span className="icon">{activeSection === 2 ? '−' : '+'}</span>
            </button>

            {/* Accordion content */}
            {activeSection === 2 && (
              <div>
                <div className="accordion-content scrollable">
                  {/* FAQ 1 */}
                  <div className="container">
                    <div className={`accordion-item ${activeFaqIndex === 3 ? 'active' : ''}`}>
                      <button
                        className="accordion-header"
                        onClick={() => setActiveFaqIndex(activeFaqIndex === 3 ? null : 3)}
                      >
                        <span>
                          What is vegan Yeast Protein and why is it important for skin health?
                        </span>
                        <span className="icon">{activeFaqIndex === 3 ? '−' : '+'}</span>
                      </button>

                      {activeFaqIndex === 3 && (
                        <div
                          className="accordion-content"
                          style={{ padding: '8px 16px' }}
                        >
                          <p>content here...</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* FAQ 2 */}
                  <div className="container">
                    <div className={`accordion-item ${activeFaqIndex === 4 ? 'active' : ''}`}>
                      <button
                        className="accordion-header"
                        onClick={() => setActiveFaqIndex(activeFaqIndex === 4 ? null : 4)}
                      >
                        <span>What are the benefits of taking vegan Yeast Protein daily?</span>
                        <span className="icon">{activeFaqIndex === 4 ? '−' : '+'}</span>
                      </button>

                      {activeFaqIndex === 4 && (
                        <div
                          className="accordion-content"
                          style={{ padding: '8px 16px' }}
                        >
                          <p>content here...</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* FAQ 3 */}
                  <div className="container">
                    <div className={`accordion-item ${activeFaqIndex === 5 ? 'active' : ''}`}>
                      <button
                        className="accordion-header"
                        onClick={() => setActiveFaqIndex(activeFaqIndex === 5 ? null : 5)}
                      >
                        <span>Can vegan Yeast Protein reduce wrinkles and fine lines?</span>
                        <span className="icon">{activeFaqIndex === 5 ? '−' : '+'}</span>
                      </button>

                      {activeFaqIndex === 5 && (
                        <div
                          className="accordion-content"
                          style={{ padding: '8px 16px' }}
                        >
                          <p>content here...</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* FAQ 4 */}
                  <div className="container">
                    <div className={`accordion-item ${activeFaqIndex === 6 ? 'active' : ''}`}>
                      <button
                        className="accordion-header"
                        onClick={() => setActiveFaqIndex(activeFaqIndex === 6 ? null : 6)}
                      >
                        <span>Can I take vegan Yeast Protein while pregnant?</span>
                        <span className="icon">{activeFaqIndex === 6 ? '−' : '+'}</span>
                      </button>

                      {activeFaqIndex === 6 && (
                        <div
                          className="accordion-content"
                          style={{ padding: '8px 16px' }}
                        >
                          <p>content here...</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Read More / Less */}
                <div className="accordion-content scrollable">
                  {/* Show Read More button only */}
                  {!showFaqs && (
                    <p
                      className="read-more"
                      onClick={() => setShowFaqs(true)}
                      style={{
                        color: 'blue',
                        cursor: 'pointer',
                        marginBottom: '12px',
                      }}
                    >
                      Read More
                    </p>
                  )}

                  {/* FAQ Accordion */}
                  {showFaqs && (
                    <>
                      <div className="container">
                        {faqs.map((faq, index) => (
                          <div
                            key={index} // Unique key for React
                            className={`accordion-item ${activeFaqIndex === index ? 'active' : ''}`}
                          >
                            <button
                              className="accordion-header"
                              onClick={() =>
                                setActiveFaqIndex(activeFaqIndex === index ? null : index)
                              }
                            >
                              <span className="scrollable">{faq.question}</span>
                              <span className="icon">{activeFaqIndex === index ? '−' : '+'}</span>
                            </button>

                            {/* FAQ answer content */}
                            {activeFaqIndex === index && (
                              <div
                                className="accordion-content"
                                style={{ padding: '8px 16px' }}
                              >
                                <p>{faq.answer}</p>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>

                      {/* Read Less button */}
                      <p
                        className="read-more"
                        onClick={() => setShowFaqs(false)}
                        style={{
                          color: 'blue',
                          cursor: 'pointer',
                          marginTop: '12px',
                        }}
                      >
                        Read Less
                      </p>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ================= Additional Information ================= */}
        <div className="container">
          <div className={`accordion-item ${activeSection === 25 ? 'active' : ''}`}>
            <button
              className="accordion-header"
              onClick={() => toggleSection(25)}
            >
              <span>Additional information</span>
              <span className="icon">{activeSection === 25 ? '−' : '+'}</span>
            </button>

            <div className="accordion-content">
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                  {Object.entries(productData || {}).map(([key, value]) => (
                    <tr key={key}>
                      <td style={{ fontWeight: 'bold', padding: '10px' }}>{key}</td>
                      <td style={{ padding: '10px' }}>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Sticky Cart Box Start --> */}
      <div className="sticky-bottom-cart">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="cart-content">
                <div className="product-image">
                  <img
                    src="/assets/images/Yeast_protein1.jpg"
                    className="img-fluid blur-up lazyload"
                    alt="img"
                  />
                  <div className="content">
                    <h5>Evercore Yeast Protein - Double Chocolate</h5>
                    <div style={{ display: 'flex', marginTop: '10px' }}>
                      <h5 className="price">
                        <span className="gradintback">
                          <span>₹749</span> <del style={{ color: '#4d4c4a' }}>₹899</del>
                        </span>
                      </h5>
                      <span
                        style={{
                          margin: '0 10px',
                          padding: '6px',
                          background: '#ff4f4f1a',
                          color: '#ff4f4f',
                          borderRadius: '7px',
                        }}
                      >
                        55% off
                      </span>
                    </div>
                  </div>
                </div>
                <div className="selection-section">
                  <div className="form-group mb-0">
                    <select
                      id="input-state"
                      className="form-control form-select"
                    >
                      <option
                        selected
                        disabled
                      >
                        Choose Weight...
                      </option>
                      <option>7 sachets</option>
                      <option>1 KG</option>
                    </select>
                  </div>
                </div>
                <div className="add-btn d-flex">
                  <div className="cart_qty qty-box product-qty m-0">
                    <div className="input-group h-100">
                      <button
                        type="button"
                        className="qty-left-minus"
                        data-type="minus"
                        data-field=""
                      >
                        <i className="fa fa-minus"></i>
                      </button>
                      <input
                        className="form-control input-number qty-input"
                        type="text"
                        name="quantity"
                        value="1"
                      />
                      <button
                        type="button"
                        className="qty-right-plus"
                        data-type="plus"
                        data-field=""
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <a
                    className="btn pro-acc-logout-btn text-white"
                    href="/Checkout"
                  >
                    <i className="fas fa-shopping-cart"></i> Buy Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Related Product Section Start --> */}
      <section className="product-list-section section-b-space">
        <div className="container-fluid-lg">
          <div className="title text-center">
            <h2>Recently Viewed</h2>
          </div>
          <div className="row">
            <div className="col-12">
              <div
                className="slider-6_1 product-wrapper"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <div>
                  <div className="product-box-3 wow fadeInUp">
                    <div className="product-header">
                      <div className="combo-image">
                        <a href="/Productdetails">
                          <img
                            src="/assets/images/Yeast_Protein.png"
                            alt="img"
                            style={{ width: '60%' }}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    className="product-box-3 wow fadeInUp"
                    data-wow-delay="0.05s"
                  >
                    <div className="product-header">
                      <div className="combo-image">
                        <a href="/Productdetails">
                          <img
                            src="/assets/images/Yeast_protein1.jpg"
                            alt="img"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Related Product Section End --> */}

      <Footer />
    </>
  );
};

export default Productdetails;
